import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const generateCommentsPDF = (bookTitle, pageNumber, sortedCommentData, userName) => {
  if (!sortedCommentData || sortedCommentData.length === 0) {
    alert("No comments available to download.");
    return;
  }

  // Generate timestamp (DD/MM/YYYY HH:MM:SS)
  const now = new Date();
  const formattedDate = now.toLocaleString("en-GB", { hour12: false }).replace(",", "");

  // Create a hidden div to format the content before converting to PDF
  const hiddenDiv = document.createElement("div");
  hiddenDiv.style.position = "absolute";
  hiddenDiv.style.left = "-9999px";
  hiddenDiv.style.width = "800px"; // Fixed width for better formatting
  hiddenDiv.style.padding = "20px";
  hiddenDiv.style.backgroundColor = "white";

  // Add Book Title (H1)
  hiddenDiv.innerHTML += `<h1 style="text-align: center; font-size: 24px; font-weight: bold;">${bookTitle}</h1>`;

  // Add Page Number & DateTime
  hiddenDiv.innerHTML += `<p style="text-align: center; font-size: 14px; color: #555;">
    Page Number: ${pageNumber} | ${formattedDate}
  </p>`;

  // Add comments
  sortedCommentData.forEach((commentItem) => {
    const commentHTML = `
      <div style="border-bottom: 1px solid #ddd; padding: 10px; margin-bottom: 10px;">
        <h4 style="font-size: 16px; font-weight: bold; color: #333;">${commentItem.notesType}</h4>
        <p style="font-size: 14px; font-weight: bold; color: #007bff;">${commentItem.notesTitle}</p>
        <p style="font-size: 12px; color: #555;"><strong>Details:</strong><br>${commentItem.notesText}</p>
        <p style="font-size: 12px; color: #777;"><strong>By:</strong> ${commentItem.notesBy}</p>
        <p style="font-size: 12px; color: #999;"><strong>Date:</strong> ${commentItem.dateCreated}</p>
      </div>
    `;
    hiddenDiv.innerHTML += commentHTML;
  });

  document.body.appendChild(hiddenDiv); // Append the div to the document

  // Convert to PDF
  html2canvas(hiddenDiv, { scale: 2 }).then((canvas) => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const imgWidth = 190; // Fit within A4 width
    const pageHeight = 297; // A4 height
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 20;

    let pageNumberCounter = 1;

    const addHeaderFooter = (pdf) => {
      pdf.setFontSize(10);
      pdf.setTextColor(100);

      // Header: Book Title
      pdf.text(bookTitle, 10, 10);

      // Footer: User Name & Generated By Text
      pdf.text(
        `${userName} - Generated by Think5Whys Immersive Learning Ecosystem`,
        10,
        pageHeight - 15
      );

      // Footer: Page Number
      pdf.text(`Page ${pageNumberCounter}`, pdf.internal.pageSize.width - 30, pageHeight - 15);
    };

    pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
    addHeaderFooter(pdf);
    heightLeft -= pageHeight - 30;

    while (heightLeft > 0) {
      pdf.addPage();
      pageNumberCounter++;
      position = heightLeft - imgHeight;
      pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
      addHeaderFooter(pdf);
      heightLeft -= pageHeight - 30;
    }

    // Generate file name
    const safeBookTitle = bookTitle.replace(/[^a-zA-Z0-9]/g, "_");
    const safeUserName = userName.replace(/[^a-zA-Z0-9]/g, "_");
    const fileName = `Notes_For_${safeBookTitle}_Page_${pageNumber}_${safeUserName}.pdf`;

    pdf.save(fileName);
    document.body.removeChild(hiddenDiv); // Clean up the hidden div
  });
};

export default generateCommentsPDF;
